import React from 'react';
import styles from './OrderFrequencyLabel.module.scss';

interface OrderFrequencyLabelProps {
    frequency: string;
}
export default function OrderFrequencyLabel({ frequency }: OrderFrequencyLabelProps) {
    if(!frequency) {
        return null;
    }
    return (
    <div className={styles.label}>
       {frequency}
    </div>
    )
}